const ja = {
  placeholderText: "入力してください",
  closeContentText: "現在の会話を終了しますか？",
  cancelText: "​​キャンセル",
  okText: "ОК",
  loadingAnswerQuestions: "前回のご質問に回答中です。送信はお待ちください。",
  networkAnomalyText:
    "ネットワークに異常が発生しました。後でもう一度お試しください",
  errorText: "サーバーエラー",
  messageTooShort: "少なくとも2文字を入力する必要があります。",
  messageTooLong: "200文字以内で入力してください。",
  systemErrorText:
    "​​システムエラーが発生しました。しばらくしてからもう一度お試しください。​​​",
  fileSizeExceeded: "1ファイルのサイズは{maxSize}MBを超えてはいけません。",
  abnormalDisconnectionText: "接続が切断されました。再接続中です...",
  evaluationText: "皆様のご評価が私たちの成長の源です",
  emailLabel: "メールアドレス​",
  emailPlaceholder: "メールアドレスを入力してください",
  emailErrorText: "メールアドレスの形式が正しくありません。",
  productLabel: "商品",
  productPlaceholder: "商品を選択してください",
  problemLabel: "問題の詳細",
  problemPlaceholder: "問題の内容を詳しくご記入ください",
  submitText: "送信する",
  submitField:
    "申し訳ございません、送信に失敗しました。しばらくしてから再試行してください。",
  thankText:
    "ご協力いただきありがとうございます。できるだけ早くご連絡いたします！メールをご確認いただくか、{link} して返信メッセージをご確認ください！",
  clickHere: "こちらをクリック​​​",
  thankEvaluation: "ご評価いただきありがとうございます",
  codeLabel: "認証コード",
  codePlaceholder: "認証コードを入力してください",
  submittedSuccessfully: "送信成功",
  supportContact: "サポート窓口",
  stillCancel: "キャンセルを続行​",
  useDiscount: "割引を利用する",
  pauseDuration: "一時停止期間",
  uploadAttachment: "ファイルを添付する",
};
export default ja;
